import React from 'react';
import _ from "lodash";
import * as echarts from 'echarts~5';

import style from './index.module.scss';
import { DEFAULT_OPTION, DEFAULT_LINE_COLOR } from './utils';

import { Spin } from 'antd';
import DomResize from 'components/DomResize';

export default class Comp extends React.Component {

    constructor(props) {
        super(props);

        const hideIdList = (props?.config?.meta_list ?? [])
            .filter(({ tagName }) =>
                (props?.config?.blackListHide ?? []).includes(tagName)
            )
            .map(({ id }) => id);

        this.state = {
            hideIdList
        };

        this.chartNode = null;
        this.chartInstance = null;
    }

    componentDidMount() {
        this.initChart();
        this.updateChart(this.props.config, this.props.lineData);
    }

    componentDidUpdate(prevProps, prevState) {

        const propsChanged =
            prevProps.config !== this.props.config ||
            prevProps.lineData !== this.props.lineData;

        const stateChanged =
            prevState.hideIdList !== this.state.hideIdList;

        if (propsChanged || stateChanged) {
            this.updateChart(this.props.config, this.props.lineData);
        }
    }

    componentWillUnmount() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
    }

    initChart = () => {
        if (!this.chartNode) {
            return;
        }

        this.chartInstance = echarts.getInstanceByDom(this.chartNode);

        if (!this.chartInstance) {
            this.chartInstance = echarts.init(this.chartNode);
        }
    }

    updateChart = (config, data) => {

        if (!this.chartNode || !config) {
            return;
        }

        this.initChart();

        let option = _.cloneDeep(DEFAULT_OPTION);

        const { hideIdList } = this.state;

        option.series = (config?.meta_list ?? [])
            .filter(({ id }) => !hideIdList.includes(id))
            .map((item) => {

                const item_data =
                    data?.[item?.tag_name ?? null] ?? [];

                return {
                    name: item?.name ?? "--",
                    data: item_data,
                    type: item?.type === "bar" ? "bar" : "line",
                    itemStyle: {
                        color: item?.color ?? DEFAULT_LINE_COLOR,
                    },
                    symbol: 'none',
                };
            });

        if (!!option?.yAxis?.[0]) {
            option.yAxis[0] = {
                ...option.yAxis[0]
            };
        }

        if (!!option?.yAxis?.[1]) {
            option.yAxis[1] = {
                ...option.yAxis[1]
            };
        }

        this.chartInstance.setOption(option, true);
    }

    refFunc = (refNode) => {
        this.chartNode = refNode;
    }

    onResize = () => {
        if (this.chartInstance) {
            this.chartInstance.resize();
        }
    }

    hide = (item) => {

        const { hideIdList } = this.state;

        let nHideIdList = [];

        if (hideIdList.includes(item.id)) {
            nHideIdList = hideIdList.filter(v => v !== item.id);
        } else {
            nHideIdList = [...hideIdList, item.id];
        }

        this.setState({
            hideIdList: nHideIdList
        });
    }

    render() {

        const { config, loading } = this.props;
        const { hideIdList } = this.state;

        return (
            <div className={style["wrapper"]}>

                <div className="header">

                    <div className="colored_bar"></div>

                    <div className="title">
                        {config?.title ?? "--"}
                    </div>

                    <div style={{ marginLeft: "auto" }}></div>

                    <div className="right">
                        {
                            (config?.meta_list ?? []).map((item, index) => {

                                const { name, color, id } = item;

                                return (
                                    <div
                                        className={
                                            "item" +
                                            (hideIdList.includes(id) ? ' hide' : '')
                                        }
                                        key={index}
                                        onClick={() => this.hide(item)}
                                    >
                                        <div
                                            className="colored_line"
                                            style={{
                                                backgroundColor:
                                                    color ?? DEFAULT_LINE_COLOR
                                            }}
                                        />

                                        <div className="item_title">
                                            {name ?? "--"}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>

                <div className="content">

                    <div className="resize_wrapper">
                        <DomResize onResize={this.onResize} />
                    </div>

                    <div
                        ref={this.refFunc}
                        style={{
                            height: '100%',
                            position: 'relative'
                        }}
                    />
                </div>

                {
                    loading === true && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255,255,255,0.7)'
                            }}
                        >
                            <Spin />
                        </div>
                    )
                }
            </div>
        );
    }
}